import { Box, Typography } from "@mui/material";
import { useTheme } from "../../components/context/context";
import img from '../../assets/imgs/Map-Megh.png'
import BasicTable from "../../components/basicTable/BasicTable";
import Downloader from "../../components/pdf_downloader/Downloader";

export default function Area(){
    const {fontSize} = useTheme();
    return(
        <Box sx={{}}>
            <Typography variant="h1" sx={{fontSize:`${fontSize+0.5}rem`, margin:"5px 0"}}>Community & Rural Development Blocks in Meghalaya</Typography>
            <hr/>
            <Box sx={{padding: "2px 0 2px 10px", marginTop: "20px", width:"100%"}}>
                 <div style={{display:"flex", width:"100%", justifyContent:"center"}}>
                    <img src={img} alt="block map" style={{maxWidth:"100%"}}/>
                 </div>
                 <br/>
                 <div style={{display:"flex", justifyContent:"center", width:"100%"}}>

                <BasicTable heading={heading} data={data}/>
                 </div>
            </Box>
        </Box>
    )
}
const heading=[
    {
        data:"Serial Number",
        width:"15%"
    },
    {
        data:"District Name",
        width:"30%"
    },
    {
        data:"Serial Number",
        width:"15%"
    },
    {
        data:"Block Name",
        width:"40%"
    },
]

const data=[
    ["1","East Khasi Hills District","1",<Downloader url={"pdf/areaVillage/mylliem.pdf"} name={"Mylliem C & RD Block"}/>],
    ["","","2",<Downloader url={"pdf/areaVillage/mawphlang.pdf"} name={"Mawphlang C & RD Block"}/>],
    ["","","3",<Downloader url={"pdf/areaVillage/mawsynram.pdf"} name={"Mawsynram C & RD Block"}/>],
    ["","","4",<Downloader url={"pdf/areaVillage/shella-bholaganj.pdf"} name={"Shella Bholaganj C & RD Block"}/>],
    ["","","5",<Downloader url={"pdf/areaVillage/pynursla.pdf"} name={"Pynursla C & RD Block"}/>],
    ["","","6",<Downloader url={"pdf/areaVillage/khadarshnong-laitkroh.pdf"} name={"Khatarshnong Laitkroh C & RD Block"}/>],
    ["","","7",<Downloader url={"pdf/areaVillage/mawkynrew.pdf"} name={"Mawkynrew C & RD Block"}/>],
    ["","","8",<Downloader url={"pdf/areaVillage/mawryngkneng.pdf"} name={"Mawryngkneng C & RD Block"}/>],
    ["","","9",<Downloader url={"pdf/areaVillage/sohiong.pdf"} name={"Sohiong C & RD Block"}/>],
    ["","","10",<Downloader url={"pdf/areaVillage/mawpat.pdf"} name={"Mawpat C & RD Block"}/>],
    ["","","11",<Downloader url={"pdf/areaVillage/mawlai.pdf"} name={"Mawlai C & RD Block"}/>],
    ["2","West Khasi Hills District","12",<Downloader url={"pdf/areaVillage/mawthadraishan.pdf"} name={"Mawthadraishan C & RD Block"}/>],
    ["","","13",<Downloader url={"pdf/areaVillage/nongstoin.pdf"} name={"Nongstoin C & RD Block"}/>],
    ["","","14",<Downloader url={"pdf/areaVillage/mawshynrut.pdf"} name={"Mawshynrut C & RD Block"}/>],
    ["","","15", "Ri-Muliang C & RD Block"],
    ["","","16","Shallang C & RD Block"],
    ["3","South West Khasi Hills District","17",<Downloader url={"pdf/areaVillage/mawkyrwat.pdf"} name={"Mawkyrwat C & RD Block"}/>],
    ["","","18",<Downloader url={"pdf/areaVillage/ranikor.pdf"} name={"Ranikor C & RD Block"}/>],
    ["4","Eastern West Khasi Hills District","19","Mairang C & RD Block"],
    ["","","20","Mawthadraishan C & RD Block"],
    ["5","Ri Bhoi District","21",<Downloader url={"pdf/areaVillage/umsning.pdf"} name={"Umsning C & RD Block"}/>],
    ["","","22",<Downloader url={"pdf/areaVillage/umling.pdf"} name={"Umling C & RD Block"}/>],
    ["","","23",<Downloader url={"pdf/areaVillage/jirang.pdf"} name={"Jirang C & RD Block"}/>],
    ["","","24",<Downloader url={"pdf/areaVillage/bhoirymbong.pdf"} name={"Bhoirymbong C & RD Block"}/>],
    ["6","West Jaintia Hills District","25",<Downloader url={"pdf/areaVillage/thadlaskein.pdf"} name={"Thadlaskein C & RD Block"}/>],
    ["","","26",<Downloader url={"pdf/areaVillage/laskein.pdf"} name={"Laskein C & RD Block"}/>],
    ["","","27",<Downloader url={"pdf/areaVillage/amlarem.pdf"} name={"Amlarem C & RD Block"}/>],
    ["","","28","Namdong C & RD Block"],
    ["7","East Jaintia Hills District","29","Wapung C & RD Block"],
    ["","","30",<Downloader url={"pdf/areaVillage/saipung.pdf"} name={"Saipung C & RD Block"}/>],
    ["","","31","Lumshnong C & RD Block"],
    ["8","East Garo Hills District","32",<Downloader url={"pdf/areaVillage/dambo-rongjeng.pdf"} name={"Dambo Rongjeng C & RD Block"}/>],
    ["","","33",<Downloader url={"pdf/areaVillage/songsak.pdf"} name={"Songsak C & RD Block"}/>],
    ["","","34",<Downloader url={"pdf/areaVillage/samanda.pdf"} name={"Samanda C & RD Block"}/>],
    ["9","West Garo Hills District","35",<Downloader url={"pdf/areaVillage/rongram.pdf"} name={"Rongram C & RD Block"}/>],
    ["","","36",<Downloader url={"pdf/areaVillage/dadenggre.pdf"} name={"Dadenggre C & RD Block"}/>],
    ["","","37",<Downloader url={"pdf/areaVillage/selsella.pdf"} name={"Selsella C & RD Block"}/>],
    ["","","38",<Downloader url={"pdf/areaVillage/tikrikilla.pdf"} name={"Tikrikilla C & RD Block"}/>],
    ["","","39",<Downloader url={"pdf/areaVillage/gambegre.pdf"} name={"Gambegre C & RD Block"}/>],
    ["","","40",<Downloader url={"pdf/areaVillage/dalu.pdf"} name={"Dalu C & RD Block"}/>],
    ["","","41",<Downloader url={"pdf/areaVillage/demdema.pdf"} name={"Demdema C & RD Block"}/>],
    ["","","42","Batabari C & RD Block"],
    ["10","North Garo Hills District","43",<Downloader url={"pdf/areaVillage/resubelpara.pdf"} name={"Resubelpara C & RD Block"}/>],
    ["","","44",<Downloader url={"pdf/areaVillage/kharkutta.pdf"} name={"Kharkutta C & RD Block"}/>],
    ["","","45",<Downloader url={"pdf/areaVillage/bajengdoba.pdf"} name={"Bajengdoba C & RD Block"}/>],
    ["","","46","Adokgre C & RD Block"],
    ["11","South West Garo Hills District","47",<Downloader url={"pdf/areaVillage/betasing.pdf"} name={"Betasing C & RD Block"}/>],
    ["","","48",<Downloader url={"pdf/areaVillage/zikzak.pdf"} name={"Zikzak C & RD Block"}/>],
    ["","","49",<Downloader url={"pdf/areaVillage/damalgre.pdf"} name={"Damalgre C and R DBlock"}/>],
    ["","","50","Purakhasia C & RD Block *"],
    ["12","South Garo Hills District","51",<Downloader url={"pdf/areaVillage/baghmara.pdf"} name={"Baghmara C & RD Block"}/>],
    ["","","52",<Downloader url={"pdf/areaVillage/gasuapara.pdf"} name={"Gasuapara C & RD Block"}/>],
    ["","","53",<Downloader url={"pdf/areaVillage/rongara.pdf"} name={"Rongara C & RD Block"}/>],
    ["","","54",<Downloader url={"pdf/areaVillage/chokpot.pdf"} name={"Chokpot C & RD Block"}/>],
    ["","","55","Siju C & RD Block"],
]